import type { FeatureModule } from "@theg1group/feature-kit";
import { lazy } from "react";

// Live shared-table test surface — console.g1.network/table. Renders the
// @theg1group/ui `ListTable` over ~200 rows of synthetic data so the operator
// table look (search · column filters · pagination · sticky header · density ·
// persisted state) can be exercised inside real console chrome before the
// wider rollout. Client-only: no API calls, no PII (`apiPaths: []`), so it
// needs no backend page-gating. Nav visibility resolves via `canViewRoute`
// (rbac-ui) → `console.table:view`; root/console admins (`*`, `console.*:view`)
// see it automatically.
export const tableDemoFeature: FeatureModule = {
	id: "table-demo",
	nav: [
		{
			id: "table",
			label: "Table Demo",
			path: "/table",
			group: "Platform",
			order: 99,
			icon: "Table2",
			actions: ["view"],
			apiPaths: [],
		},
	],
	routes: [
		{
			path: "/table",
			component: lazy(() => import("@/pages/TableDemo").then((m) => ({ default: m.TableDemo }))),
		},
	],
};
